import Progress from "../ValueObject/Progress";
import DocumentDownload from "../Entity/DocumentDownload";

export const ADD_DOWNLOAD: string = 'Download/ADD_DOWNLOAD';
export const ADD_CURRENT_DOWNLOAD: string = 'Download/ADD_CURRENT_DOWNLOAD';
export const PAUSE_DOWNLOAD: string = 'Download/PAUSE_DOWNLOAD';
export const RESUME_DOWNLOAD: string = 'Download/RESUME_DOWNLOAD';
export const CANCEL_DOWNLOAD: string = 'Download/CANCEL_DOWNLOAD';
export const CANCEL_CURRENT_DOWNLOAD: string = 'Download/CANCEL_CURRENT_DOWNLOAD';
export const PROCESS_DOWNLOAD: string = 'Download/PROCESS_DOWNLOAD';
export const FINISH_DOWNLOAD: string = 'Download/FINISH_DOWNLOAD';
export const MOVE_UP_DOWNLOAD: string = 'Download/MOVE_UP_DOWNLOAD';
export const MOVE_DOWN_DOWNLOAD: string = 'Download/MOVE_DOWN_DOWNLOAD';
export const CHANGE_PROGRESS_DOWNLOAD: string = 'Download/CHANGE_PROGRESS_DOWNLOAD';

export type Action<T> = {
    content: T;
    type: string;
};

export function addDownload(document: DocumentDownload): Action<DocumentDownload> {
    return {
        content: document,
        type: ADD_DOWNLOAD
    };
}

export function addCurrentDownloadAction(): Action<null> {
    return {
        content: null,
        type: ADD_CURRENT_DOWNLOAD
    };
}

export function pauseDownload(): Action<null> {
    return {
        content: null,
        type: PAUSE_DOWNLOAD
    };
}

export function resumeDownload(): Action<null> {
    return {
        content: null,
        type: RESUME_DOWNLOAD
    };
}

export function cancelDownload(id: number): Action<number> {
    return {
        content: id,
        type: CANCEL_DOWNLOAD
    };
}

export function cancelCurrentDownload(): Action<null> {
    return {
        content: null,
        type: CANCEL_CURRENT_DOWNLOAD
    };
}

export function processDownload(): Action<null> {
    return {
        content: null,
        type: PROCESS_DOWNLOAD
    };
}

export function finishDownload(): Action<null> {
    return {
        content: null,
        type: FINISH_DOWNLOAD
    };
}

export function moveUpDownload(id: number): Action<number> {
    return {
        content: id,
        type: MOVE_UP_DOWNLOAD
    };
}

export function moveDownDownload(id: number): Action<number> {
    return {
        content: id,
        type: MOVE_DOWN_DOWNLOAD
    };
}

export function changeProgressDownload(progress: Progress): Action<Progress> {
    return {
        content: progress,
        type: CHANGE_PROGRESS_DOWNLOAD
    }
}